import { render, staticRenderFns } from "./institutionsCollection.vue?vue&type=template&id=2182ee7f&"
import script from "./institutionsCollection.vue?vue&type=script&lang=js&"
export * from "./institutionsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports